import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { LINKED_DATASETS_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_automation_linked_datasets_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { LinkedDataset, LinkedDatasets } from '@/types/datasets.ts';

import { fetchDatasetInventory } from '@/hooks/api/datasets/fetchDatasetInventory.ts';

const useRetrieveLinkedDatasets = (): UseQueryResult<LinkedDatasets, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: LINKED_DATASETS_KEY(automationId),
    queryFn: ({ signal }) =>
      fetchDatasetInventory<LinkedDataset>(
        apiClient,
        get_automation_linked_datasets_url(automationId),
        signal,
      ),
    enabled: !!automationId,
  });
};

export default useRetrieveLinkedDatasets;
